import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var CartCardLabel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 1px ", "px;\n  border-radius: ", "px;\n  ", "\n  font-size: 11px;\n  display: inline-block;\n"], ["\n  padding: 1px ", "px;\n  border-radius: ", "px;\n  ", "\n  font-size: 11px;\n  display: inline-block;\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxxs;
}, function (props) {
  var _a;

  return (props === null || props === void 0 ? void 0 : props.background) && "\n  background: ".concat(props.background, ";\n  color: ").concat((_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white, ";");
});
var templateObject_1;
export { CartCardLabel };